@if (pendingRequest) {
  @if (expanded) {
    <section class="conflict-notification alert alert-warning shadow" role="status">
      <div class="d-flex align-items-start gap-3">
        <div class="flex-grow-1">
          <div class="fw-semibold">This loan has conflicting updates</div>
          <div class="small">
            A background update changed {{ pendingRequest.conflicts.length }} field{{ pendingRequest.conflicts.length === 1 ? '' : 's' }}
            while you were editing. Review the incoming values before applying them.
          </div>
        </div>
        <div class="d-flex gap-2 flex-shrink-0">
          <button type="button" class="btn btn-warning btn-sm" (click)="openResolution()">
            Resolve conflicts
          </button>
          <button type="button" class="btn-close" aria-label="Collapse notification" (click)="collapse()"></button>
        </div>
      </div>
    </section>
  } @else {
    <button
      type="button"
      class="conflict-indicator btn btn-warning shadow"
      (click)="expand()">
      Loan update conflicts ({{ pendingRequest.conflicts.length }})
    </button>
  }
}
